import type { GroupedSelectPopoverProps } from '../GroupedSelectPopover';

import METRICS_INFO_IMAGE from '../../assets/images/metric-info.png';
import { ItemInfoSection } from './ItemInfoSection';
import { usePopoverResizeObserver } from '~/hooks';
import { useGroupedSelect } from '../../stores';
import { Scrollable } from '@shopify/polaris';
import { useState } from 'react';

interface WrapperItemInfoSectionProps {
  popoverActive: boolean;
  control: GroupedSelectPopoverProps;
}

export const WrapperItemInfoSection: React.FC<WrapperItemInfoSectionProps> = ({
  popoverActive,
  control,
}) => {
  const { config, minHeight, dependentControls } = control;
  const { itemInfo, generalItemInfo, thumbnail } = config || {};

  const { itemHovered } = useGroupedSelect();
  const info = itemHovered ? itemInfo?.[itemHovered] : generalItemInfo;

  const [maxHeight, setMaxHeight] = useState<number | undefined>(undefined);

  usePopoverResizeObserver({
    active: popoverActive,
    onHeightChange: (PopoverHeight) => {
      setMaxHeight(PopoverHeight);
    },
  });

  return (
    <Scrollable
      scrollbarWidth="thin"
      className="bg-surface-secondary p-3"
      style={{
        maxHeight: maxHeight ? `${maxHeight}px` : undefined,
        minHeight,
        overscrollBehavior: 'contain',
      }}
    >
      <ItemInfoSection
        info={info || generalItemInfo}
        thumbnail={thumbnail || METRICS_INFO_IMAGE}
        dependentControls={dependentControls}
      />
    </Scrollable>
  );
};
